if (!customElements.get('trust-indicators')) {
  class TrustIndicators extends HTMLElement {
    constructor() {
      super();


      this.initSlider();
    }

    initSlider() {
      var swiperArea = this.querySelector('.swiper');
      this.slider = new Swiper(swiperArea, {
        slidesPerView: 1,
        autoplay: true,
        loop: true,
        spaceBetween: 21,
        breakpoints: {
          750: {
            spaceBetween: 21,
            slidesPerView: 3
          },
          990: {
            spaceBetween: 21,
            slidesPerView: 4
          }
        }
      });
    }
  }

  customElements.define('trust-indicators', TrustIndicators);
}
